import './bullet.tag'

riot.tag2('bullet-bar', '<h4 class="bullet-bar__label" onclick="{onClick}">{opts.data.name}</h4> <div class="bullet-bar__bar-wrapper"> <div class="bullet-bar__spacer"></div> <div class="bullet-bar__bar" riot-style="width:{value / 3}%;" onclick="{onClick}"></div> <span each="{tick in ticks}" if="{value > tick}" class="bullet-bar__tick {bullet-bar__tick--50 : tick === 50}" riot-style="left:{tick / 3}%;"> <span>{tick}&nbsp;mg</span> </span> <bullet each="{meas in opts.measurements}" data="{meas}"></bullet> </div>', '', 'class="bullet-bar"', function(opts) {

  this.value = this.opts.data.mVal
  this.ticks = [50, 100, 150, 200, 250]
  this.onClick = () => riot.control.trigger(riot.EVT.updateCityInfobox, this.opts.data)
});



// WEBPACK FOOTER //
// ./src/components/bullet-bar/bullet-bar.tag